var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Área destinada à recuperação (em hectares):",
                  content: _vm.pratica.areaDestinada
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label:
                    "Data que o processo de recuperação foi iniciado (mês e ano):",
                  content: _vm.formataDataInicio(_vm.pratica.dataInicio)
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Grau de degradação da área:",
                  content: _vm.formataGrauDegradacao(_vm.pratica.grauDegradacao)
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Foi realizada análise de solo antes da recuperação?:",
                  content: _vm.pratica.hasAnaliseSolo ? "Sim" : "Não"
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Técnica utilizada na recuperação da área:",
                  content: _vm.formataTecnicasUtilizadas(
                    _vm.pratica.tecnicasUtilizadas
                  )
                }
              }),
              _vm._v(" "),
              _vm.pratica.tecnicasUtilizadas &&
              _vm.pratica.tecnicasUtilizadas.length
                ? _c("app-display", {
                    attrs: {
                      label: "Outras técnicas utilizadas:",
                      content: _vm.pratica.outrosTecnicasUtilizadas
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: {
          bioinsumo: {
            utilizaBioinsumos: _vm.pratica.utilizaBioinsumos,
            bioinsumos: _vm.pratica.bioinsumos
          }
        }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          irrigacao: Object.assign(
            {},
            { possuiIrrigacao: _vm.pratica.possuiIrrigacao },
            _vm.pratica.irrigacao
          )
        }
      }),
      _vm._v(" "),
      _c("Financiamento", {
        attrs: {
          financiamento: {
            financiamentos: _vm.pratica.financiamentos,
            outroFinanciamento: _vm.pratica.outroFinanciamento
          }
        }
      }),
      _vm._v(" "),
      _c("Descricao", { attrs: { descricao: _vm.pratica.descricao } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da prática")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33b8a646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b8a646","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/PRPD/PRPD.vue
// module id = null
// module chunks = 